module.exports = __webpack_public_path__ + "img/0-pdp-ams-wireless-vibration-monitor.e2f532a1.png";